(() => {
    if (customElements.get('fade-bg-effect')) return;

    class FadeBgEffect extends HTMLElement {
        parentElement = this.closest('.shopify-section');

        canvas = this.querySelector('canvas');
        ctx = this.canvas.getContext('2d');

        circles = [];
        fadeDuration = 2000;

        color = this.dataset.rgb;

        acceleration = { x: 0, y: 0 };

        constructor() {
            super();
            this.animate = this.animate.bind(this);
        }

        async connectedCallback() {
            this.init();
            await window.hoculus.Utils.waitForInteraction();
            this.querySelector('.code').style.opacity = 1;
        }

        init() {
            this.setCanvasSize();

            const ON_CHANGE_DEBOUNCE_TIMER = 300;
            window.addEventListener('resize', window.hoculus.Utils.debounce(this.setCanvasSize.bind(this), ON_CHANGE_DEBOUNCE_TIMER));

            this.animate();

            // Will do nothing if the device does not support accelerometer or permission is denied
            this.initAccelerometer();

            this.parentElement.addEventListener("mousemove", (event) => {
                this.addCircle(event.clientX, event.clientY + window.scrollY);
            });
        }

        initAccelerometer() {
            if (window.DeviceMotionEvent && !DeviceMotionEvent.requestPermission) {
                if (window.innerWidth <= 1024) this.setupAccelerometer();
            } else {
                console.warn("Accelerometer not supported on this device.");

                // If device not supporter, use touch events instead
                this.parentElement.addEventListener("touchmove", (event) => {
                    this.addCircle(event.touches[0].clientX, event.touches[0].clientY + window.scrollY);
                });
            }
        }

        setupAccelerometer() {
            if (!('Accelerometer' in window)) return;

            try {
                const acl = new Accelerometer({ frequency: 60 });
                acl.addEventListener("reading", () => {
                    this.acceleration.x = -acl.x * 100; // Scale movement
                    this.acceleration.y = -acl.y * 100;

                    const centerX = this.canvas.width / 2 + this.acceleration.x;
                    const centerY = this.canvas.height / 2 - this.acceleration.y - 800;

                    this.addCircle(centerX, centerY);
                });

                acl.start();
            } catch (error) {
                console.error("Error initializing Accelerometer:", error);
            }
        }

        setCanvasSize() {
            this.canvas.width = this.parentElement.clientWidth;
            this.canvas.height = this.parentElement.clientHeight;
        }

        addCircle(x, y) {
            this.circles.push({ x, y, startTime: Date.now() });
        }

        drawCircle({ x, y, startTime }) {
            const elapsed = Date.now() - startTime;
            const progress = elapsed / this.fadeDuration;
            const alpha = Math.max(0.5 - progress, 0);
            const radius = 700 * Math.max(progress, 0.05);

            // Create a radial gradient with fading alpha
            const gradient = this.ctx.createRadialGradient(x, y, 0, x, y, radius);
            gradient.addColorStop(0, `rgba(${this.color}, ${alpha})`); // green center
            gradient.addColorStop(1, `rgba(${this.color}, 0)`); // fades out
            this.ctx.fillStyle = gradient;
            this.ctx.beginPath();
            this.ctx.arc(x, y, radius, 0, Math.PI * 2);
            this.ctx.fill();
        }

        animate() {
            // Clear the entire canvas on each frame
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            // Draw and update circles
            for (let i = this.circles.length - 1; i >= 0; i--) {
                const circle = this.circles[i];
                const elapsed = Date.now() - circle.startTime;
                if (elapsed > this.fadeDuration) {
                    // Remove circle when its fade duration is over
                    this.circles.splice(i, 1);
                } else {
                    this.drawCircle(circle);
                }
            }
            requestAnimationFrame(this.animate);
        }
    }

    customElements.define('fade-bg-effect', FadeBgEffect);
})();